import { render, staticRenderFns } from "./DashboardFiguresNew.vue?vue&type=template&id=1507cd2d&scoped=true"
import script from "./DashboardFiguresNew.vue?vue&type=script&lang=ts"
export * from "./DashboardFiguresNew.vue?vue&type=script&lang=ts"
import style0 from "./DashboardFiguresNew.vue?vue&type=style&index=0&id=1507cd2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507cd2d",
  null
  
)

export default component.exports